import {
    activityCategories,
    ActivityCategory,
    activityCategoryLabels,
    ActivityRecordType,
} from "@sp-crm/core";
import { activityCategoryIcons } from "components/tasks/activity-category-icons";
import {
    activityTypeChoicesForRecordType,
    ActivityTypeOption,
    byActivityTypeName,
    useActivityTypeOptions,
} from "components/tasks/activity-type-options";
import { SecondaryCompactButton } from "components/ui/secondary-button";
import React from "react";

interface ActivityTypePickListProps {
    categories: readonly ActivityCategory[];
    recordType: ActivityRecordType;
    onPickType: (option: ActivityTypeOption) => void;
    onPickUntyped: () => void;
}

export const ActivityTypePickList: React.FC<ActivityTypePickListProps> = props => {
    const { categories, recordType, onPickType, onPickUntyped } = props;
    const options = useActivityTypeOptions();

    return (
        <div className="space-y-1">
            {activityCategories
                .filter(category => categories.includes(category))
                .map(category => {
                    const categoryOptions = activityTypeChoicesForRecordType(
                        options,
                        category,
                        recordType,
                        null,
                    ).sort(byActivityTypeName);
                    if (categoryOptions.length === 0 && category !== "other") {
                        return null;
                    }
                    const CategoryIcon = activityCategoryIcons[category];
                    return (
                        <div
                            key={category}
                            className="flex flex-wrap items-start gap-x-2">
                            <div className="my-2 flex w-16 flex-shrink-0 items-center gap-1 py-1">
                                <CategoryIcon
                                    aria-hidden="true"
                                    className="h-4 w-4 flex-shrink-0 text-gray-500"
                                />
                                <span className="text-xs font-medium text-gray-500">
                                    {activityCategoryLabels[category]}
                                </span>
                            </div>
                            <div className="my-2 flex min-w-0 flex-1 flex-wrap items-center gap-1.5">
                                {categoryOptions.map(option => (
                                    <SecondaryCompactButton
                                        key={option.id}
                                        type="button"
                                        onClick={() => onPickType(option)}>
                                        {option.name}
                                    </SecondaryCompactButton>
                                ))}
                                {category === "other" ? (
                                    <SecondaryCompactButton
                                        type="button"
                                        onClick={onPickUntyped}>
                                        Task
                                    </SecondaryCompactButton>
                                ) : null}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};
